import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=458e1b27&"
import script from "./Offers.vue?vue&type=script&lang=js&"
export * from "./Offers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Projekte/woerner-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('458e1b27')) {
      api.createRecord('458e1b27', component.options)
    } else {
      api.reload('458e1b27', component.options)
    }
    module.hot.accept("./Offers.vue?vue&type=template&id=458e1b27&", function () {
      api.rerender('458e1b27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/woerner/Offers.vue"
export default component.exports